// extracted by mini-css-extract-plugin
export var filterIncDec = "_dw-0";
export var leftBorder = "_dw-1";
export var rightBorder = "_dw-2";
export var stringInput = "_dw-3";